import { configureStore } from "@reduxjs/toolkit";
import { rootReducer } from "./rootReducer";
import createSagaMiddleware from "redux-saga";
import { rootSaga } from "./rootSaga";
import { pizzaWayAPI } from './pizzaWayAPI';

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware => getDefaultMiddleware().concat(pizzaWayAPI.middleware).concat(sagaMiddleware))
});

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;